import React, { FC } from 'react';
import './Gallery.scss';
import SectionTitle from '../../../../components/SectionTitle/SectionTitle';
const gallery_1 = require('../../../../assets/images/gallery_1.jpg');
const gallery_2 = require('../../../../assets/images/gallery_2.jpg');
const gallery_3 = require('../../../../assets/images/gallery_3.jpg');
const gallery_4 = require('../../../../assets/images/gallery_4.jpg');
const gallery_5 = require('../../../../assets/images/gallery_5.jpg');
const gallery_6 = require('../../../../assets/images/gallery_6.jpg');
const gallery_7 = require('../../../../assets/images/gallery_7.jpg');
const gallery_8 = require('../../../../assets/images/gallery_8.jpg');
const gallery_9 = require('../../../../assets/images/gallery_9.jpg');

type Props = {
  id: string
}
const Gallery:FC<Props> = ({id}) => {

  return (
    <section id={id} className='section-common gallery-section section-m section-p'  data-aos="fade-up" data-aos-duration="1000">
      <div className="container">
        <SectionTitle
          title="Galeria"
          description="Zapraszamy do zapoznania się z galerią zdjęć. Dbamy o to, aby przestrzeń była przyjazna, nowoczesna i komfortowa dla każdego pacjenta."
        />
        <div id="galleryCarousel" className="carousel slide" data-bs-ride="carousel">
          <div className="carousel-indicators">
            <button type="button" data-bs-target="#galleryCarousel" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
            <button type="button" data-bs-target="#galleryCarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
            <button type="button" data-bs-target="#galleryCarousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
            <button type="button" data-bs-target="#galleryCarousel" data-bs-slide-to="3" aria-label="Slide 4"></button>
            <button type="button" data-bs-target="#galleryCarousel" data-bs-slide-to="4" aria-label="Slide 5"></button>
            <button type="button" data-bs-target="#galleryCarousel" data-bs-slide-to="5" aria-label="Slide 6"></button>
            <button type="button" data-bs-target="#galleryCarousel" data-bs-slide-to="6" aria-label="Slide 7"></button>
            <button type="button" data-bs-target="#galleryCarousel" data-bs-slide-to="7" aria-label="Slide 8"></button>
            <button type="button" data-bs-target="#galleryCarousel" data-bs-slide-to="8" aria-label="Slide 9"></button>   
          </div>
          
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img src={gallery_1} className="d-block w-100" alt="zdjęcie gabinetu" />
            </div>
            <div className="carousel-item">
              <img src={gallery_2} className="d-block w-100" alt="zdjęcie gabinetu" />
            </div>
            <div className="carousel-item">
              <img src={gallery_3} className="d-block w-100" alt="zdjęcie gabinetu" />
            </div>
            <div className="carousel-item">
              <img src={gallery_4} className="d-block w-100" alt="zdjęcie gabinetu" />
            </div>
            <div className="carousel-item">
              <img src={gallery_5} className="d-block w-100" alt="zdjęcie gabinetu" />
            </div>
            <div className="carousel-item">
              <img src={gallery_6} className="d-block w-100" alt="zdjęcie poczekalni" />
            </div>
            <div className="carousel-item">
              <img src={gallery_7} className="d-block w-100" alt="zdjęcie loga zlota centrum zdrowia" />
            </div>
            <div className="carousel-item">
              <img src={gallery_8} className="d-block w-100" alt="zdjęcie loga zlota centrum zdrowia" />
            </div>
            <div className="carousel-item">
              <img src={gallery_9} className="d-block w-100" alt="zdjęcie budynku zlota centrum zdrowia" />
            </div>
          </div>
          
          <button className="carousel-control-prev" type="button" data-bs-target="#galleryCarousel" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#galleryCarousel" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Gallery;